/** @jsx jsx */
import { jsx } from '@emotion/react';
import {
  BaseButton,
  Props as BaseButtonProps,
} from '../../navigation/Button/BaseButton';

type Props = Omit<
  BaseButtonProps,
  | 'children'
  | 'color'
  | 'iconBefore'
  | 'isFullWidth'
  | 'isPill'
  | 'isSquare'
  | 'size'
> & {
  /** Optional prop, set to true if this button is in the selected state. */
  selected?: boolean;
  /** The button's contents. We only want to allow number values here. */
  value: number;
};

/**
 * `NumberButton`s are `Button`s that render numbers within them, such as page buttons for paginated collections.
 */
export function NumberButton({ selected, value, ...buttonProps }: Props) {
  return (
    <BaseButton
      {...buttonProps}
      color="number"
      isSquare={true}
      isSelected={selected}
      size="small"
    >
      {value}
    </BaseButton>
  );
}
